import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function updateNestedFieldSelectorDataReducer(state = initialState.nestedFieldSelectorData, action) {
  switch (action.type) {
    case types.UPDATE_NESTED_FIELD_SELECTOR_DATA:
      return Object.assign({}, state, {
        ...action.dataToBeUpdated,
      });
    case types.RESET_NESTED_FIELD_SELECTOR_DATA:
      return initialState.nestedFieldSelectorData;
    default:
      return state;
  }
}
